import React from 'react'
import { FirebaseAppProvider } from 'reactfire';

import firebaseConfig from './config'

const Provider = ({ children }) => (
  <FirebaseAppProvider firebaseConfig={firebaseConfig}>
    {children}
  </FirebaseAppProvider>
)

export default Provider
